export const mockEmpDashboardList = {
  response: {
    // User details
    userDetails: {
      id: 1,
      firstName: "John",
      lastName: "Doe",
      email: "john.doe@example.com",
      birthDate: new Date().toISOString().split('T')[0], // Today's date
      acctType: "USER",
      department: "Engineering",
      position: "Software Engineer",
      joinDate: "2023-01-15"
    },

    // Timesheet related data
    rejectedTimesheets: [
      {
        id: 1,
        startDate: "2024-04-01",
        endDate: "2024-04-07",
        status: "REJ",
        reason: "Incorrect hours logged",
        projectName: "Project Alpha"
      },
      {
        id: 2,
        startDate: "2024-04-08",
        endDate: "2024-04-14",
        status: "REJ",
        reason: "Missing project details",
        projectName: "Project Beta"
      }
    ],
    pendingTimesheets: [
      {
        id: 3,
        startDate: "2024-04-15",
        endDate: "2024-04-21",
        status: "PEN",
        projectName: "Project Gamma"
      }
    ],
    approvedTimesheets: [
      {
        id: 4,
        startDate: "2024-03-25",
        endDate: "2024-03-31",
        status: "APP",
        projectName: "Project Delta"
      }
    ],

    // Document related data
    expiredDocuments: [
      {
        id: 1,
        name: "Passport",
        expiryDate: "2024-04-30",
        type: "IDENTITY",
        status: "EXPIRED"
      },
      {
        id: 2,
        name: "Work Permit",
        expiryDate: "2024-05-15",
        type: "WORK",
        status: "EXPIRING_SOON"
      }
    ],
    pendingDocuments: [
      {
        id: 3,
        name: "Tax Form",
        dueDate: "2024-05-01",
        type: "TAX",
        status: "PENDING"
      }
    ],

    // Approval related data
    pendingApprovals: [
      {
        id: 1,
        type: "LEAVE",
        startDate: "2024-05-01",
        endDate: "2024-05-05",
        status: "PENDING",
        reason: "Annual Leave"
      },
      {
        id: 2,
        type: "EXPENSE",
        date: "2024-04-20",
        amount: 150.00,
        status: "PENDING",
        description: "Business Travel"
      }
    ],

    // Performance metrics
    performanceMetrics: {
      totalHoursThisMonth: 160,
      targetHours: 160,
      efficiency: 95,
      attendance: 100,
      projectsCompleted: 3,
      pendingTasks: 5
    },

    // Recent activity
    recentActivity: [
      {
        id: 1,
        type: "TIMESHEET",
        action: "SUBMITTED",
        date: "2024-04-22",
        details: "Timesheet for week 16 submitted"
      },
      {
        id: 2,
        type: "DOCUMENT",
        action: "UPLOADED",
        date: "2024-04-21",
        details: "Updated passport uploaded"
      }
    ],

    // Project overview
    projects: [
      {
        id: 1,
        name: "Project Alpha",
        status: "IN_PROGRESS",
        progress: 75,
        deadline: "2024-06-30"
      },
      {
        id: 2,
        name: "Project Beta",
        status: "ON_HOLD",
        progress: 30,
        deadline: "2024-07-15"
      }
    ],

    // Notifications
    notifications: [
      {
        id: 1,
        type: "ALERT",
        message: "Timesheet rejected for week 15",
        date: "2024-04-20",
        read: false
      },
      {
        id: 2,
        type: "REMINDER",
        message: "Document expiry reminder: Passport",
        date: "2024-04-19",
        read: true
      }
    ]
  },
  loading: false,
  error: null
}; 